/**
 * AlphaX Tuning Simulator - Drag Strip Manager
 */

let dragPhase = 'idle'; 
let dragTimer = 0;
let dragSimSpeed = 1;
let dragDist = 0, dragVel = 0, dragGear = 0, dragTime = 0;
let dragIsShifting = false;
let dragShiftTimer = 0;
let dragSplits = {};
let dragTorqueDisplay = 0;
let dragGForce = 0;
let dragReactionTimer = 0;
let dragReactionTime = null;
let dragRedLight = false;

// --- Leaderboard Data ---
const LEADERBOARD_API_URL = "https://script.google.com/macros/s/AKfycbyNJCAuBHN8BHH2wUxMrYwO9mE3I40y70m4zUNjsRm_CSO8X8uB_oKOfXqOeZdZ6H8d/exec";
let dragMaxHp = 0;
let dragMaxTq = 0;

// --- Clutch State ---
let clutchEngagement = 1.0;   // 0 = fully slipping, 1 = locked
let clutchSlipTimer = 0;      // seconds since GO signal (gear 0)
let clutchHeat = 0;           // 0–100 (%)
let clutchFailed = false;
let isClutchSlipping = false;

// --- Launch Spin Penalty ---
let launchSpinPenaltyActive = false;
let launchSpinPenaltyTimer  = 0;
let dragLastTps = 0;

// --- Manual Mode State ---
let dragManualMode = false;
let dragClutchPressed = false;
let dragThrottlePressed = false;
let dragManualSlipTimer = 0;

function initDragListeners() {
}

function updateDragHud(text, color) {
    const hud = document.getElementById('drag-hud-status');
    if (hud) {
        hud.innerText = text;
        hud.style.color = color;
    }
}

const DRAG_SETTINGS_IDS = [
    'drag-weight', 'drag-launch-rpm', 'drag-shift-rpm', 'drag-shift-delay',
    'drag-treadwear', 'drag-clutch-slip-time',
    'chk-reaction-mode', 'chk-manual-mode', 'chk-no-shift-on-slip'
];

function _setDragSettingsLocked(locked) {
    DRAG_SETTINGS_IDS.forEach(id => {
        const el = document.getElementById(id);
        if (!el) return;
        el.disabled = locked;
        el.classList.toggle('opacity-40', locked);
        el.classList.toggle('cursor-not-allowed', locked);
        el.classList.toggle('pointer-events-none', locked);
    });
}

function startDragRun(speed) {
    if (typeof isEngineRunning !== 'undefined' && !isEngineRunning) {
        const pwrBtn = document.getElementById('btn-power');
        if (pwrBtn) pwrBtn.click();
    }
    _setDragSettingsLocked(true);
    dragSimSpeed = speed;
    dragPhase = 'staging1';
    dragTimer = 0;
    dragDist = 0;
    dragVel = 0;
    dragGear = 0;
    dragTime = 0;
    dragIsShifting = false;
    dragShiftTimer = 0;
    dragSplits = {};
    dragTorqueDisplay = 0;
    dragGForce = 0;
    clutchEngagement = 1.0;
    clutchSlipTimer = 0;
    clutchHeat = 0;
    clutchFailed = false;
    isClutchSlipping = false;
    launchSpinPenaltyActive = false;
    launchSpinPenaltyTimer  = 0;
    dragLastTps = 0;
    dragClutchPressed = false;
    dragThrottlePressed = false;
    dragManualSlipTimer = 0;
    document.getElementById('drag-clutch-slip-ind')?.classList.add('hidden');
    document.getElementById('drag-clutch-fail-ind')?.classList.add('hidden');
    const _chBar = document.getElementById('clutch-heat-bar');
    if (_chBar) { _chBar.style.width = '0%'; _chBar.style.backgroundColor = '#22c55e'; }
    const _chLabel = document.getElementById('clutch-heat-label');
    if (_chLabel) _chLabel.innerText = 'CLUTCH: 0%';
    datalogRows = [];
    logTimeAccumulator = 0;
    if (physics) physics.knockCount = 0;
    
    ["60ft", "330ft", "18Mile", "1000ft", "14Mile"].forEach(id => {
        const splitEl = document.getElementById(`split-${id}`);
        if (splitEl) {
            splitEl.innerText = "--";
            splitEl.classList.replace('text-green-400', 'text-white');
        }
    });

    dragReactionTimer = 0;
    dragReactionTime = null;
    dragRedLight = false;
    dragMaxHp = 0;
    dragMaxTq = 0;
    const launchBtn = document.getElementById('btn-drag-launch');
    if (launchBtn) launchBtn.classList.add('hidden');
    const submitWrap = document.getElementById('leaderboard-submit-wrap');
    if (submitWrap) {
        submitWrap.classList.add('hidden');
    }
    const reasonEl = document.getElementById('drag-lb-reason');
    if (reasonEl) {
        reasonEl.classList.add('hidden');
        reasonEl.innerText = "";
    }
    const submitBtn = document.getElementById('btn-submit-drag');
    if (submitBtn) {
        submitBtn.innerText = T('submit_to_leaderboard', 'Submit to Leaderboard');
        submitBtn.disabled = false;
    }
    const reactionRow = document.getElementById('slip-reaction-row');
    if (reactionRow) reactionRow.classList.add('hidden');
    const redLightRow = document.getElementById('slip-redlight-row');
    if (redLightRow) redLightRow.classList.add('hidden');
    const reactionEl = document.getElementById('split-reaction');
    if (reactionEl) reactionEl.textContent = '—';

    if (document.getElementById('chk-reaction-mode')?.checked) {
        if (launchBtn) launchBtn.classList.remove('hidden');
    }

    updateDragHud('READY...', '#fbbf24');
    updateCategoryTicker();
}

function launchCar() {
    const isStaging = dragPhase === 'staging1' || dragPhase === 'staging2' || dragPhase === 'staging3' || dragPhase === 'staging4';
    if (dragPhase !== 'waitForLaunch' && !isStaging) return;

    if (dragPhase === 'waitForLaunch') {
        dragReactionTime = dragReactionTimer;
        dragRedLight = false;
    } else {
        dragReactionTime = -dragReactionTimer;
        dragRedLight = true;
    }

    dragPhase = 'pull';
    document.getElementById('btn-drag-launch')?.classList.add('hidden');

    // Show reaction time in timeslip immediately
    const reactionRow = document.getElementById('slip-reaction-row');
    if (reactionRow) reactionRow.classList.remove('hidden');
    const reactionEl = document.getElementById('split-reaction');
    if (reactionEl) {
        reactionEl.textContent = dragReactionTime.toFixed(3) + 's';
        reactionEl.style.color = dragRedLight ? '#f87171' : '#fde047';
    }

    if (dragRedLight) {
        document.getElementById('slip-redlight-row')?.classList.remove('hidden');
        _showRedLightToast();
    }
}

function _showRedLightToast() {
    const toast = document.createElement('div');
    toast.textContent = '🔴 RED LIGHT';
    toast.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);background:#ef4444;color:#fff;font-weight:900;font-size:1.1rem;letter-spacing:.15em;padding:10px 28px;border-radius:8px;box-shadow:0 4px 24px rgba(239,68,68,.5);z-index:9999;pointer-events:none;transition:opacity .4s';
    document.body.appendChild(toast);
    setTimeout(() => { toast.style.opacity = '0'; }, 1400);
    setTimeout(() => toast.remove(), 1850);
}

function abortDragRun() {
    if (dragPhase !== 'idle' && dragPhase !== 'finished') {
        dragPhase = 'finished';
        _setDragSettingsLocked(false);
        if (audio) audio.setScreech(false);
        const slipInd = document.getElementById('drag-slip-ind');
        if (slipInd) slipInd.classList.add('hidden');
        document.getElementById('drag-clutch-slip-ind')?.classList.add('hidden');
        document.getElementById('drag-clutch-fail-ind')?.classList.add('hidden');
        const launchBtn = document.getElementById('btn-drag-launch');
        if (launchBtn) launchBtn.classList.add('hidden');
        updateDragHud('PASS ABORTED', '#ef4444');
        if (typeof exportDatalog === 'function') exportDatalog('Drag');
    }
}

function manualShift() {
    if (dragManualMode) return;
    let validGears = currentTransmission.gears.filter(g => g > 0);
    if (typeof appMode !== 'undefined' && appMode === 'drag' && dragPhase === 'pull' && !dragIsShifting && dragGear < validGears.length - 1) {
        dragIsShifting = true;
        dragShiftTimer = 0;
    }
}

function onManualModeToggle(e) {
    dragManualMode = e.target.checked;
    dragClutchPressed = false;
    dragThrottlePressed = false;

    const hint = document.getElementById('manual-mode-hint');
    if (hint) hint.classList.toggle('hidden', !dragManualMode);

    const ff = document.getElementById('btn-drag-ff');
    const inst = document.getElementById('btn-drag-instant');
    [ff, inst].forEach(btn => {
        if (!btn) return;
        btn.disabled = dragManualMode;
        btn.classList.toggle('opacity-40', dragManualMode);
        btn.classList.toggle('cursor-not-allowed', dragManualMode);
    });

    // In manual mode, launch is triggered by releasing C — hide the button
    const launchBtn = document.getElementById('btn-drag-launch');
    if (launchBtn && dragManualMode) launchBtn.classList.add('hidden');
}

function isRunStock() {
    if (!sampleEngine || !physics) return false;
    
    const weightDef = sampleEngine.global_specs?.default_vehicle_weight_lbs || 2270;
    const w = parseFloat(document.getElementById('drag-weight')?.value) || 2270;
    const sDel = parseFloat(document.getElementById('drag-shift-delay')?.value) || 0.3;

    const isStockMods = physics.activeMods.length === 0;
    const isNitrous = ecu.nitrousEnabled;
    const isManual = document.getElementById('chk-manual-mode')?.checked;
    
    // Transmission name check
    const stockTransId = sampleEngine.default_transmission?.trans_id || "Engine Default";
    const isStockTrans = currentTransmission?.name === stockTransId;
    
    // Stock requires default weight, 0.3s shift delay, and Auto Mode
    const settingsStock = (
        Math.abs(w - weightDef) < 0.1 &&
        Math.abs(sDel - 0.3) < 0.01 &&
        !isManual
    );
    
    // Note: launch control (LC/two-step) does NOT disqualify from Stock.
    const isSmartAlt  = !!ecu.smartAltEnabled;
    const isHighOctane = (ecu.fuelOctane || 91) > 93;
    const isFlexFuel   = (ecu.ethanolContent || 0) > 0;

    return isStockMods && !isNitrous && isStockTrans && settingsStock
        && !isSmartAlt && !isHighOctane && !isFlexFuel;
}

function isLeaderboardEligible() {
    const reasons = [];

    // 1. Advanced Mode
    if (typeof advancedMode === 'undefined' || !advancedMode) {
        reasons.push('Advanced Mode must be enabled');
    }

    // 2. VVT closed-loop PID (only required when engine has VVT)
    const vvtMode = sampleEngine?.vvt_parameters?.vvt_mode;
    if (vvtMode && vvtMode.toLowerCase() !== 'none') {
        if (!ecu.vvtPhaserEnabled) {
            reasons.push('VVT Closed-Loop PID must be enabled (this engine has VVT)');
        }
    }

    // 3. Ambient temp = 80 °F
    const ambTemp = parseFloat(document.getElementById('sim-ambient-temp')?.value);
    if (ambTemp !== 80) {
        reasons.push(`Ambient temp must be 80°F (currently ${ambTemp}°F)`);
    }

    // 4. Baro = 101.3 kPa
    const baro = parseFloat(document.getElementById('sim-baro')?.value);
    if (Math.abs(baro - 101.3) > 0.05) {
        reasons.push(`Barometric pressure must be 101.3 kPa (currently ${baro} kPa)`);
    }

    // 5. Humidity = 60%
    const hum = parseFloat(document.getElementById('sim-hum')?.value);
    if (hum !== 60) {
        reasons.push(`Humidity must be 60% (currently ${hum}%)`);
    }

    // 6. ECT simulation enabled (read global, not disabled DOM checkbox)
    if (typeof coolantSimEnabled === 'undefined' || !coolantSimEnabled) {
        reasons.push('ECT (Coolant) Simulation must be enabled');
    }

    // 7. O2 transport delay enabled (read ecu property, not disabled DOM checkbox)
    if (!ecu.o2DelayEnabled) {
        reasons.push('O2 Sensor Transport Delay must be enabled');
    }

    // 8. Knock overlay disabled
    if (document.getElementById('sim-knock-overlay')?.checked) {
        reasons.push('Knock Indicator Overlay must be disabled');
    }

    // 9. Accel enrichment not none
    if (!ecu.accelMode || ecu.accelMode === 'none') {
        reasons.push('Accel Enrichment must be enabled (MS Adder or MAP Prediction)');
    }

    // 10. Fuel pressure model enabled (read ecu property, not disabled DOM checkbox)
    if (!ecu.fuelPressureModelEnabled) {
        reasons.push('Fuel Pressure Model must be enabled');
    }

    return { eligible: reasons.length === 0, reasons };
}

function getTreadwearLabel() {
    return document.getElementById('drag-treadwear')?.value || 'Economy';
}

function getDragCategory() {
    if (isRunStock()) return 'Stock';
    const hasTurbo = physics.activeMods.some(m => m.mod_type === 'Turbocharger');
    const hasSupercharger = physics.activeMods.some(m => m.mod_type === 'Supercharger');
    const hasNitrous = ecu.nitrousEnabled;
    const hasBoost = hasTurbo || hasSupercharger;
    if (hasBoost && hasNitrous) return 'Super Power Adder';
    if (hasBoost || hasNitrous) return 'Power Adder';
    return 'Modified N/A';
}

function updateCategoryTicker() {
    const el = document.getElementById('drag-category-ticker');
    if (!el) return;
    const cat = getDragCategory();
    const label = `${cat} (${getTreadwearLabel()})`;
    el.textContent = label;
    const colorMap = {
        'Stock': 'text-green-400',
        'Modified N/A': 'text-yellow-300',
        'Power Adder': 'text-orange-400',
        'Super Power Adder': 'text-red-400'
    };
    el.className = `text-[10px] font-black font-mono tracking-wide ${colorMap[cat] || 'text-yellow-300'}`;
    updateCategoryCheckBtn();
}

function updateCategoryCheckBtn() {
    const btn = document.getElementById('btn-category-check');
    if (!btn || !sampleEngine || !physics || !ecu) return;

    const elg = isLeaderboardEligible();

    const weightDef = sampleEngine.global_specs?.default_vehicle_weight_lbs || 2270;
    const w = parseFloat(document.getElementById('drag-weight')?.value) || 2270;
    const sDel = parseFloat(document.getElementById('drag-shift-delay')?.value) || 0.3;
    const hasHardViolation = (w < weightDef * 0.5) || (sDel < 0.1);

    const disqualifiedFromAll = !elg.eligible || hasHardViolation;
    const stockEligible = elg.eligible && !hasHardViolation && isRunStock();

    btn.disabled = stockEligible;

    if (disqualifiedFromAll) {
        btn.className = 'text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded border border-red-500/70 text-red-400 shadow-[0_0_8px_rgba(239,68,68,0.45)] transition-colors';
    } else if (stockEligible) {
        btn.className = 'text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded border border-green-800 text-green-600 bg-green-950/40 cursor-not-allowed opacity-60';
    } else {
        // Modified-eligible, not Stock
        btn.className = 'text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded border border-yellow-600/50 text-yellow-500 shadow-[0_0_6px_rgba(234,179,8,0.25)] hover:text-yellow-300 transition-colors';
    }
}

function submitLeaderboard() {
    // --- Red light disqualification ---
    if (dragRedLight) {
        alert("Run disqualified: red light. Complete a clean pass to submit.");
        return;
    }

    // --- Universal eligibility check ---
    const eligibility = isLeaderboardEligible();
    if (!eligibility.eligible) {
        alert("Submission rejected — the following conditions must be met:\n\n• " + eligibility.reasons.join('\n• '));
        return;
    }

    const weightDef = sampleEngine.global_specs?.default_vehicle_weight_lbs || 2270;
    const w = parseFloat(document.getElementById('drag-weight')?.value) || 2270;
    const sDel = parseFloat(document.getElementById('drag-shift-delay')?.value) || 0.3;

    if (Math.abs(w - weightDef) > 0.1) {
        alert(`Submission rejected: Vehicle weight must be the engine's default (${weightDef} lbs).`);
        return;
    }
    if (sDel < 0.1) {
        alert("Submission rejected: Minimum allowed shift delay is 0.1s.");
        return;
    }

    const submitCat  = getDragCategory();
    const octRule    = getClassOctaneRule(submitCat);
    const submitOct  = ecu.fuelOctane || 91;
    const submitFlex = (ecu.ethanolContent || 0) > 0;

    if (!octRule.flexAllowed && submitFlex) {
        alert(`Submission rejected: ${submitCat} class does not allow flex fuel.`);
        return;
    }
    if (octRule.flexMutuallyExclusive && submitFlex && submitOct > 93) {
        alert(`Submission rejected: ${submitCat} class — when using flex fuel, base octane must be ≤93 AKI (currently ${submitOct} AKI). Use flex fuel OR race gas, not both.`);
        return;
    }
    if (!submitFlex && submitOct > octRule.maxOctane) {
        alert(`Submission rejected: ${submitCat} class requires fuel octane ≤${octRule.maxOctane} AKI without flex fuel (currently ${submitOct} AKI).`);
        return;
    }

    const btn = document.getElementById('btn-submit-drag');
    const nameInput = document.getElementById('lb-display-name');
    const displayName = nameInput?.value.trim();

    if (!displayName) {
        alert("Please enter a display name for the leaderboard.");
        nameInput?.focus();
        return;
    }

    if (btn) {
        btn.innerText = T('submitting', 'Submitting...');
        btn.disabled = true;
    }

    const playerId = window.shopifyCustomer?.id
        || window.shopifyCustomer?.email
        || window.Shopify?.customer?.id
        || 'Guest';

    let activeModsList = physics.activeMods.map(m => m.display_name || m.name).join(', ');
    if (ecu.nitrousEnabled) {
        activeModsList += (activeModsList ? ', Nitrous' : 'Nitrous');
    }
    if (!activeModsList) activeModsList = 'None';

    const finalCategory = `${getDragCategory()} (${getTreadwearLabel()})`;

    // --- ET includes reaction time for manual/reaction-time mode runs ---
    const isManualRun = dragManualMode || document.getElementById('chk-reaction-mode')?.checked;
    const submittedEt = isManualRun ? (dragTime + (dragReactionTime || 0)) : dragTime;

    const payload = {
        authKey: "AX_SECRET_GSP_2024", // Match backend/leaderboards.gs
        engineName: sampleEngine.global_specs?.display_name || sampleEngine.global_specs?.engine_id || "Unknown Engine",
        category: finalCategory,
        playerName: displayName,
        playerId: playerId, // Backend handles column J now
        et: submittedEt.toFixed(3),
        mph: (dragVel * 2.237).toFixed(1),
        hp: dragMaxHp.toFixed(0),
        tq: dragMaxTq.toFixed(0),
        mods: activeModsList
    };

    fetch(LEADERBOARD_API_URL, {
        method: 'POST',
        body: JSON.stringify(payload)
    }).then(res => res.json())
      .then(data => {
          if (btn) btn.innerText = T('submitted', 'Submitted!');
          // Save the display name for next time
          localStorage.setItem('lb_preferred_name', displayName);
      })
      .catch(err => {
          console.error(err);
          if (btn) {
              btn.innerText = T('error_retry', 'Error (Retry)');
              btn.disabled = false;
          }
      });
}

function getClassOctaneRule(category) {
    // Returns { maxOctane, flexAllowed, flexMutuallyExclusive }
    // flexMutuallyExclusive: true = flex OR race gas, not both (Modified N/A only)
    if (category === 'Stock')             return { maxOctane: 93,  flexAllowed: false, flexMutuallyExclusive: false };
    if (category === 'Modified N/A')      return { maxOctane: 100, flexAllowed: true,  flexMutuallyExclusive: true  };
    if (category === 'Power Adder')       return { maxOctane: 104, flexAllowed: true,  flexMutuallyExclusive: false };
    if (category === 'Super Power Adder') return { maxOctane: 116, flexAllowed: true,  flexMutuallyExclusive: false };
    return { maxOctane: 116, flexAllowed: true, flexMutuallyExclusive: false };
}

function showCategoryCheck() {
    if (!sampleEngine || !physics || !ecu) return;

    const weightDef = sampleEngine.global_specs?.default_vehicle_weight_lbs || 2270;
    const w = parseFloat(document.getElementById('drag-weight')?.value) || 2270;
    const sDel = parseFloat(document.getElementById('drag-shift-delay')?.value) || 0.3;

    // Universal conditions (apply to all classes)
    const elg = isLeaderboardEligible();

    // --- Stock issues ---
    const stockIssues = [...elg.reasons];

    if (physics.activeMods.length > 0)
        stockIssues.push(`Remove all modifications (${physics.activeMods.length} active)`);
    if (ecu.nitrousEnabled)
        stockIssues.push('Disable nitrous system');
    const stockTransId = sampleEngine.default_transmission?.trans_id || 'Engine Default';
    if (currentTransmission?.name !== stockTransId)
        stockIssues.push(`Use stock transmission (currently: ${currentTransmission?.name || '—'})`);
    if (Math.abs(w - weightDef) >= 0.1)
        stockIssues.push(`Reset vehicle weight to ${weightDef} lbs (currently ${w} lbs)`);
    if (Math.abs(sDel - 0.3) >= 0.01)
        stockIssues.push(`Set shift delay to 0.3s (currently ${sDel}s)`);
    if (document.getElementById('chk-manual-mode')?.checked)
        stockIssues.push('Disable Manual Mode (Stock requires Auto)');
    if (ecu.smartAltEnabled)
        stockIssues.push('Disable Smart Alternator');
    if ((ecu.fuelOctane || 91) > 93)
        stockIssues.push(`Lower fuel octane to ≤93 (currently ${ecu.fuelOctane})`);
    if ((ecu.ethanolContent || 0) > 0)
        stockIssues.push(`Set ethanol content to 0% (currently ${ecu.ethanolContent}%)`);

    // --- Per-class octane/flex rules ---
    const curCat     = getDragCategory();
    const octaneRule = getClassOctaneRule(curCat);
    const curOctane  = ecu.fuelOctane || 91;
    const curEthanol = ecu.ethanolContent || 0;
    const flexActive = curEthanol > 0;

    const classIssues = [...elg.reasons];
    if (w < weightDef * 0.5)
        classIssues.push(`Weight too low — minimum is ${(weightDef * 0.5).toFixed(0)} lbs for this engine (currently ${w} lbs)`);
    if (sDel < 0.1)
        classIssues.push(`Shift delay below minimum — must be ≥0.1s (currently ${sDel.toFixed(2)}s)`);

    if (!octaneRule.flexAllowed && flexActive) {
        classIssues.push(`${curCat} class: flex fuel not permitted`);
    } else if (octaneRule.flexMutuallyExclusive && flexActive && curOctane > 93) {
        classIssues.push(`${curCat} class: when using flex fuel, base octane must be ≤93 AKI (currently ${curOctane} AKI — use flex OR race gas, not both)`);
    } else if (!flexActive && curOctane > octaneRule.maxOctane) {
        classIssues.push(`${curCat} class: fuel octane ≤${octaneRule.maxOctane} AKI required without flex fuel (currently ${curOctane} AKI)`);
    }

    // --- Render ---
    function renderList(el, issues) {
        if (!el) return;
        if (issues.length === 0) {
            el.innerHTML = '<div class="text-green-400 font-bold text-xs flex items-center gap-1.5"><span>&#10003;</span><span>Eligible — no issues found</span></div>';
        } else {
            el.innerHTML = issues.map(issue =>
                `<div class="text-red-400 text-[11px] font-mono flex items-start gap-1.5"><span class="mt-0.5 shrink-0">&#10007;</span><span>${issue}</span></div>`
            ).join('');
        }
    }

    renderList(document.getElementById('category-check-stock'), stockIssues);
    renderList(document.getElementById('category-check-modified'), classIssues);

    document.getElementById('modal-category-check')?.classList.remove('hidden');
}

function fetchLeaderboards() {
    const tableBody = document.getElementById('leaderboard-table-body');
    if (tableBody) tableBody.innerHTML = '<tr><td colspan="7" class="text-center py-4">Loading...</td></tr>';
    
    let engineFilter = document.getElementById('lb-engine-filter')?.value;
    // If input is empty, default to current engine's display name
    if (!engineFilter && sampleEngine) {
        engineFilter = sampleEngine.global_specs?.display_name || sampleEngine.name || "";
        const input = document.getElementById('lb-engine-filter');
        if (input) input.value = engineFilter;
    }
    
    const categoryFilter = document.getElementById('lb-category-filter')?.value || "Stock";

    const url = `${LEADERBOARD_API_URL}?engine=${encodeURIComponent(engineFilter || "")}&category=${encodeURIComponent(categoryFilter)}`;
    
    fetch(url)
        .then(res => res.json())
        .then(data => {
            if (!tableBody) return;
            if (!data || data.length === 0) {
                tableBody.innerHTML = '<tr><td colspan="7" class="text-center py-4 text-gray-500 italic">No records found for this category.</td></tr>';
                return;
            }

            // Keep only the best (lowest ET) run per player name
            const bestByPlayer = {};
            data.forEach(row => {
                const key = (row.player || '').trim().toLowerCase();
                if (!key) return;
                if (!bestByPlayer[key] || parseFloat(row.et) < parseFloat(bestByPlayer[key].et)) {
                    bestByPlayer[key] = row;
                }
            });
            const dedupedData = Object.values(bestByPlayer).sort((a, b) => parseFloat(a.et) - parseFloat(b.et));

            let html = '';
            dedupedData.forEach((row, idx) => {
                html += `<tr class="border-b border-gray-700 hover:bg-gray-700/50">
                    <td class="p-2 font-bold ${idx===0 ? 'text-yellow-400' : (idx===1 ? 'text-gray-300' : (idx===2 ? 'text-orange-400' : ''))}">${idx + 1}</td>
                    <td class="p-2 text-blue-300">${row.player}</td>
                    <td class="p-2 font-mono text-green-400">${parseFloat(row.et).toFixed(3)}</td>
                    <td class="p-2 font-mono">${parseFloat(row.mph).toFixed(1)}</td>
                    <td class="p-2 font-mono text-red-400">${row.hp}</td>
                    <td class="p-2 font-mono text-orange-400">${row.tq}</td>
                    <td class="p-2 text-xs text-gray-400">${row.mods}</td>
                </tr>`;
            });
            tableBody.innerHTML = html;
        })
        .catch(err => {
            console.error(err);
            if (tableBody) tableBody.innerHTML = '<tr><td colspan="7" class="text-center py-4 text-red-500">Failed to load leaderboards.</td></tr>';
        });
}

